import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const TabNameIcon = styled('div')`
  justify-content: center;
  display: flex;
`

export const TabIcon = styled(Icon)`
  display: flex;
  align-self: flex-start;
  margin: auto;
  margin-top: 6px;

  @media (min-width: ${({ theme }) => theme.screen.mdMin}) {
    margin: auto;
    margin-right: 6px;
  }
`

export const TabName = styled('p')`
  margin: 0;
`

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-radius: 8px;
  overflow: hidden;
`

const PlaceholderContainer = `
  background: white;
  border-radius: 8px;
`

export const PlaceholderData = styled.div`
  ${PlaceholderContainer}
  margin-bottom: 24px;
  ${({ width }) => (width ? `width: ${width}px;` : '')}
`

export const SectionContainer = styled.div`
  margin: 24px 0;
`
